import { render, staticRenderFns } from "./CallFeeCommission.vue?vue&type=template&id=2f2214c2&scoped=true"
import script from "./CallFeeCommission.vue?vue&type=script&lang=js"
export * from "./CallFeeCommission.vue?vue&type=script&lang=js"
import style0 from "./CallFeeCommission.vue?vue&type=style&index=0&id=2f2214c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2214c2",
  null
  
)

export default component.exports